import type { Infer } from 'superstruct';
import { object, string } from 'superstruct';

import { parsableInteger } from './parsableInteger';

export const IdObject = object({
	id: parsableInteger(),
});
export type IdObject = Infer<typeof IdObject>;

export const IdObjectWithName = object({
	id: parsableInteger(),
	name: string(),
});
export type IdObjectWithName = Infer<typeof IdObjectWithName>;
